import { render, staticRenderFns } from "./OCTtlContent.html?vue&type=template&id=cc15e96c&scoped=true&"
import script from "./OCTtlContent.ts?vue&type=script&lang=ts&"
export * from "./OCTtlContent.ts?vue&type=script&lang=ts&"
import style0 from "./OCTtlContent.css?vue&type=style&index=0&id=cc15e96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc15e96c",
  null
  
)

export default component.exports